import { useState } from "react";
import "./HomeFaqSection.css";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLocale } from "@/i18n/useLocale";

/** Cuantas preguntas se ven de entrada. Las 16 cerradas median ~1.500px en
 * escritorio y ~1.300px en mobile; las demas siguen en el HTML (y en el
 * FAQPage), solo quedan plegadas hasta que la persona las pide.
 *
 * 11 = las cinco primeras de empleados virtuales (lo que promete el hero) mas
 * las seis que responden "que es WAIA" (ver el orden en dictionary.ts). Antes
 * eran 8, y esas seis -las que un motor de IA cita para "empresa de software
 * en Rosario"- quedaban plegadas con display:none. */
const VISIBLE_INITIALLY = 11;

function HomeFaqSection() {
  const { t } = useLocale();
  const [expanded, setExpanded] = useState(false);
  const hiddenCount = Math.max(0, t.homeFaq.items.length - VISIBLE_INITIALLY);
  const headerRef = useScrollReveal<HTMLDivElement>();
  const listRef = useScrollReveal<HTMLDivElement>({ delay: 120 });

  return (
    <section className="home-faq" id="preguntas-frecuentes">
      <div className="home-faq__container">
        <div className="home-faq__header reveal--from-left" ref={headerRef}>
          <p className="home-faq__eyebrow">{t.homeFaq.eyebrow}</p>
          <h2 className="home-faq__title">{t.homeFaq.title}</h2>
        </div>

        <div className="home-faq__list reveal--from-left" ref={listRef}>
          {t.homeFaq.items.map((item, index) => (
            <details
              key={item.question}
              className={`home-faq__item${index >= VISIBLE_INITIALLY && !expanded ? " home-faq__item--folded" : ""}`}
            >
              <summary className="home-faq__question">{item.question}</summary>
              <p className="home-faq__answer">{item.answer}</p>
            </details>
          ))}
        </div>

        {hiddenCount > 0 && (
          <button
            type="button"
            className="home-faq__more"
            aria-expanded={expanded}
            onClick={() => setExpanded((value) => !value)}
          >
            {expanded ? t.homeFaq.showLess : `${t.homeFaq.showMore} (${hiddenCount})`}
          </button>
        )}
      </div>
    </section>
  );
}

export default HomeFaqSection;
